import { getElementHeight } from '@/core/domHelpers';

export default {
  props: {
    panelTabIndex: {
      type: Number,
      default: 0
    },
    currentTabIndex: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      containerHeight: 0
    };
  },
  watch: {
    currentTabIndex: {
      immediate: true,
      handler() {
        // TODO: See why Vue.nextTick doesn't work here
        setTimeout(() => {
          this.checkCurrentTabAndEmitHeightChangeEvent();
        }, 0);
      }
    }
  },
  updated() {
    setTimeout(() => {
      this.containerHeight = getElementHeight(this.$refs['container']);
      this.checkCurrentTabAndEmitHeightChangeEvent();
    }, 0);
  },
  methods: {
    checkCurrentTabAndEmitHeightChangeEvent() {
      if (this.currentTabIndex === this.panelTabIndex) {
        if (!this.containerHeight) {
          this.containerHeight = getElementHeight(this.$refs['container']);
        }
        
        this.emitHeightChangeEvent();
      }
    },
    emitHeightChangeEvent() {
      this.$emit('setDetailRowHeight', this.containerHeight + 40);
    },
    addFilter(colId, value, filterGroupName, type, isTag, originalTag) {
      this.$emit('addFilter', {
        colId,
        value,
        filterGroupName,
        type,
        isTag,
        originalTag
      });
    },
  },
};